import axios from "axios";

const BASE_PATH = "/phone_system/tracking_numbers";

const createError = (e) => {
  const error = e.response ? e.response.data.error : "Something went wrong!";

  return { error };
};

const appendOptionalFilters = (
  path,
  trackingNumbers,
  minDate,
  maxDate,
  duration,
  outcome,
  agents,
  callers,
) => {
  const filters = new URLSearchParams();

  if (trackingNumbers.length > 0) {
    filters.append("tracking_number_ids", trackingNumbers.join(","));
  }

  if (minDate) {
    filters.append("min_date", minDate);
  }

  if (maxDate) {
    filters.append("max_date", maxDate);
  }

  if (duration) {
    filters.append("duration", duration.value);
  }

  if (outcome) {
    filters.append("outcome", outcome.value);
  }

  if (agents?.length) {
    filters.append("agents", agents.map((a) => a.value).join(","));
  }

  return `${path}${path.includes("?") ? "&" : "?"}${filters}`;
};

export const getCallLogs = async (
  trackingNumbers,
  minDate,
  maxDate,
  sortBy,
  sortDirection,
  offset,
  limit,
  filters,
) => {
  try {
    let path = `${BASE_PATH}/call_logs?sort_by=${sortBy}&sort_direction=${sortDirection}&offset=${offset}&limit=${limit}`;
    path = appendOptionalFilters(
      path,
      trackingNumbers,
      minDate,
      maxDate,
      filters.duration,
      filters.outcome,
      filters.agents,
    );

    const response = await axios.get(path);
    return response.data?.tracking_number_calls || [];
  } catch (e) {
    return createError(e);
  }
};

export const getTextLogs = async (trackingNumbers, minDate, maxDate, offset, limit) => {
  try {
    let path = `${BASE_PATH}/text_logs?offset=${offset}&limit=${limit}`;
    path = appendOptionalFilters(path, trackingNumbers, minDate, maxDate);

    const response = await axios.get(path);
    return response.data?.tracking_number_texts || [];
  } catch (e) {
    return createError(e);
  }
};

export const getStats = async (trackingNumbers, minDate, maxDate) => {
  try {
    let path = `${BASE_PATH}/stats`;
    path = appendOptionalFilters(path, trackingNumbers, minDate, maxDate);

    const response = await axios.get(path);
    return response.data;
  } catch (e) {
    return createError(e);
  }
};

export const getTrackingNumbers = async () => {
  try {
    const response = await axios.get(BASE_PATH);
    return response.data;
  } catch (e) {
    return createError(e);
  }
};

export const getCallLogCount = async (trackingNumbers, minDate, maxDate, filters) => {
  try {
    let path = `${BASE_PATH}/call_log_count`;
    path = appendOptionalFilters(
      path,
      trackingNumbers,
      minDate,
      maxDate,
      filters.duration,
      filters.outcome,
      filters.agents,
    );

    const response = await axios.get(path);
    return response.data?.log_count || 0;
  } catch (e) {
    return createError(e);
  }
};

export const getTextLogCount = async (trackingNumbers, minDate, maxDate) => {
  try {
    let path = `${BASE_PATH}/text_log_count`;
    path = appendOptionalFilters(path, trackingNumbers, minDate, maxDate);

    const response = await axios.get(path);
    return response.data?.log_count || 0;
  } catch (e) {
    return createError(e);
  }
};

export const getActivity = async (trackingNumbers, minDate, maxDate) => {
  try {
    let path = `${BASE_PATH}/activity`;
    path = appendOptionalFilters(path, trackingNumbers, minDate, maxDate);

    const { data } = await axios.get(path);

    return data?.activity;
  } catch (e) {
    return createError(e);
  }
};

export const getAgents = async () => {
  try {
    const path = `${BASE_PATH}/agents`;

    const { data } = await axios.get(path);

    return data;
  } catch (e) {
    return createError(e);
  }
};

export const getRecordingMetadata = async (recordingLink) => {
  const metadataUrl = `${recordingLink.substring(0, recordingLink.length - 4)}.json`;
  const { data } = await axios.get(metadataUrl);

  return data || {};
};
